import { useMemo } from 'react'

import { RuleFilterInput } from '@/graphql/generated/schemas'
import { useAppSelector } from '@/redux/hooks'
import { Filter } from '@/redux/types/filters'
import {
  selectIncidentRulesActionsFilter,
  selectIncidentRulesFacilityIdsFilter,
  selectIncidentRulesNameLikeFilter,
  selectIncidentRulesStatusFilter,
} from '@/redux/ui/uiSlice'

import { RULE_SEARCH_FILTER_LABEL } from '../constants/ruleSearch'

export function useRulesFilters() {
  const nameLikeFilterValue = useAppSelector(selectIncidentRulesNameLikeFilter)
  const facilityIdsFilterValue = useAppSelector(
    selectIncidentRulesFacilityIdsFilter
  )
  const actionsFilterValue = useAppSelector(selectIncidentRulesActionsFilter)
  const statusFilterValue = useAppSelector(selectIncidentRulesStatusFilter)

  const facilityIds = useMemo(
    () => facilityIdsFilterValue?.map((f) => f.value) || [],
    [facilityIdsFilterValue]
  )

  const actions = useMemo(
    () => actionsFilterValue?.map((a) => a.value) || [],
    [actionsFilterValue]
  )

  const searchFilter = useMemo(
    () => buildRuleSearchFilter(nameLikeFilterValue?.value),
    [nameLikeFilterValue]
  )

  const filters = useMemo(
    () => ({
      ...searchFilter,
      facilityIdIn: facilityIds.length > 0 ? facilityIds : undefined,
      actionIn: actions.length > 0 ? actions : undefined,
      status: statusFilterValue?.value,
    }),
    [searchFilter, facilityIds, actions, statusFilterValue]
  )

  return {
    filters,
  }
}

export const getRuleSearchFilter = (filterString: string): Filter =>
  filterString
    ? {
        value: filterString,
        label: RULE_SEARCH_FILTER_LABEL,
      }
    : null

export const buildRuleSearchFilter = (
  searchTerm?: string
): Partial<Pick<RuleFilterInput, 'OR'>> =>
  searchTerm
    ? {
        OR: [{ nameLike: searchTerm }, { deviceNameLike: searchTerm }],
      }
    : {}
